import { ISubcode } from '../models/codes.model';
import { useSelector } from 'react-redux';
import { RootState } from '../store/rootReducer';

const useCommonCode = () => {
  const { commonCodes } = useSelector((root: RootState) => root.commonCode);

  const getDetailCode = (commonCode: string): ISubcode[] => {
    return (
      commonCodes.find((item) => item.commonCode === commonCode)?.detailCode ??
      []
    );
  };

  return { getDetailCode };
};

export default useCommonCode;
